import { takeEvery, call, put } from 'redux-saga/effects';
import { MUTE_VIDEO } from '../../../store/Modal/types/VideoCreate/actions';
import { closeModal } from '../../../store/Modal/actions';
import { loadVideolists, loadVideolist } from '../../../store/ContentVideolists/actions';
import { showAlertError, showAlertSuccess } from '../../../store/Alert/actions';
import axios from 'axios';
import { loadingText, loading } from "../../../store/App/actions";
import { store } from "../../../connect";

const FORM_DATA_KEYS = ['name', 'description', 'filename', 'mute']


export default function* () {
    yield takeEvery(MUTE_VIDEO, worker);
}

function* worker({ payload }) {
    console.log("MUTE_VIDEO",{ payload });

        yield put(loading(true))
    
    try {

        const mutedVideo = yield call(fetchMute, payload)

        if (!mutedVideo.success) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${MUTE_VIDEO}.`, {}],
                text: "У ролика не была удалена аудиодорожка. Попробуйте повторить."
            }));
        } else {
            yield put(showAlertSuccess({
                text: "Аудиодорожка успешно удалена."
            }))
            yield put(closeModal("confirm"));


        }


    } catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${MUTE_VIDEO}.`, e],
            text: "У ролика не была удалена аудиодорожка. Попробуйте повторить."
        }));
    }
    finally { 
            yield put(loading(false))
        
    } 
}

function fetchMute(id) {
    
    let formData = new FormData();            
    formData.set('id', id);


    return axios({
        url: "videolist/tracks/mute",
        method: "POST",
        data: formData,
    })
        .then(response => response.data);
}


function fetchAdd(addData) {
    console.log({ addData });

    let formData = new FormData()
    if (addData && addData.songs) {
        Object.keys(addData).forEach(name => {
            formData.set(name, addData[name])
        })
    }

    return axios(
        {
            url: `/videolist/set?id=${addData.id}`,
            method: "POST",
            data: formData,

        }
    )
        .then(response => response.data)
}